import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { ITake } from "@/types/ITake";
import { GetTakesByCult } from "@/services/getCultTakesFeed";
import { IBroadCastChannel } from "@/types/IBroadcastChannel";

export const fetchCultTakesFeed = createAsyncThunk(
  "takes/GetTakesByCult",
  async (
    {
      pageNumber,
      id,
    }: { pageNumber: number; id: number },
    { rejectWithValue }
  ) => {
    try {
      const data = await GetTakesByCult(pageNumber, id);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
interface CultTakesState {
  takes: ITake[];
  pageNumber: number;
  loading: boolean;
  error: string | null;
  IsCultOnwer : boolean
  isRefetch : boolean
  cult : IBroadCastChannel
}

const initialState: CultTakesState = {
  takes: [],
  pageNumber: -1,
  loading: false,
  error: null,
  IsCultOnwer : false,
  isRefetch : false,
  cult : {} as IBroadCastChannel
};

export const CultTakeSlice = createSlice({
  name: "cultTakes_slice",
  initialState,
  reducers: {
    incrementPageNumber: (state) => {
      state.pageNumber += 1;
    },
    resetPageNumber: (state) => {
      state.pageNumber = -1;
    },
    setCult: (state , action : PayloadAction<IBroadCastChannel>) => {
      state.cult = action.payload;
    },
    setIsOnwerOfCult: (state , action : PayloadAction<boolean>) => {
      state.IsCultOnwer = action.payload;
    },
    setIsRefetch: (state) => {
      state.isRefetch = !state.isRefetch;
    },
    postMytakeAnswer: (
      state,
      action: PayloadAction<{ take_id: number; answer: number }>
    ) => {
      const { take_id, answer } = action.payload;
      const take = state.takes.find((take) => take.id === take_id);
      if (take) {
        if (answer === 1) {
          take.answer1 += 1;
        } else {
          take.answer2 += 1;
        }
      }
    },
    takeUpdated: (
      state,
      action: PayloadAction<{
        take_id: number;
        answer1: number;
        answer2: number;
      }>
    ) => {
      const { take_id, answer1, answer2 } = action.payload;
      const take = state.takes.find((take) => take.id === take_id);
      if (take) {
        take.answer1 = answer1;
        take.answer2 = answer2;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCultTakesFeed.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchCultTakesFeed.fulfilled,
        (state, action: PayloadAction<ITake[]>) => {
          state.loading = false;
          const newTakes = action.payload;
          const ids = new Set(state.takes.map((take) => take.id));
          state.takes =
            state.pageNumber === 0
              ? newTakes
              : [
                  ...state.takes,
                  ...newTakes.filter((take) => !ids.has(take.id)),
                ];
        }
      )
      .addCase(fetchCultTakesFeed.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const {
  incrementPageNumber,
  postMytakeAnswer,
  takeUpdated,
  resetPageNumber,
  setIsOnwerOfCult,
  setIsRefetch,
  setCult
} = CultTakeSlice.actions;

export default CultTakeSlice.reducer;
